import addressDataModel from './address-data.model';
import matchModel from './match.model';
import privatePackageTrackerModel from './private-package-tracker.model';
import locationModel from './location.model';

export default {
  privatePackageTrackerModel,
  addressDataModel,
  matchModel,
  locationModel
};
